import React, { useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import usePersonnelFile from '../../components/personnel-file/usePersonnelFile';
import PersonnelFileView from '../../components/personnel-file/PersonnelFileView';
import DocumentViewerModal from '../../components/ui/DocumentViewerModal';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import { useAuth } from '../../context/AuthContext';

const Container = styled.div``;

// Rota istemcide KİLİTLENMEZ (routes/index.js: privileges={[]}) — erişimi API'deki
// PersonnelFileAccess kapısı belirler (İK tam, çalışan kendi dosyası, işe alım yalnız
// adaylık dönemi). Task 9'un usePersonnelFile/PersonnelFileView bileşenleri aynen kullanılır,
// Task 11'in "Belgelerim" ekranı da aynı ikiliyi tüketeceği için prop sözleşmesi değişmez.
export default function PersonnelFileDetailPage() {
  const { employeeId } = useParams();
  const { t } = useTranslation();
  const { canWrite } = useAuth();
  const { fetching, file } = usePersonnelFile(employeeId);
  // { fileUrl, title } | null — açık olduğunda DocumentViewerModal'ı besler.
  const [viewing, setViewing] = useState(null);

  // Bu sayfaya aday listesinden gelen işe alım uzmanının (AT.Read, EM.Write YOK) liste
  // sayfasına erişimi yoktur — rota EM.Write ile kapılı. Liste kırıntısını ona da bağlantı
  // olarak vermek çıkmaz sokak olurdu (tıklayınca ana sayfaya yönlendirilirdi), bu yüzden
  // yalnız listeye ulaşabilenlerde bağlantı, diğerlerinde düz metin.
  const canReachList = canWrite ? canWrite('EM') : false;

  return (
    <Container>
      <Breadcrumbs items={[
        canReachList
          ? { label: t('personnelFile.list.title'), path: '/personnel-files' }
          : { label: t('personnelFile.list.title'), plain: true },
        { label: file?.fullName || '...' },
      ]} />
      <PersonnelFileView
        items={file?.items}
        fetching={fetching}
        onOpenFile={(item) => setViewing({
          fileUrl: item.fileUrl,
          title: t(`personnelFile.type.${item.documentType}`, { defaultValue: item.title }),
        })}
      />
      <DocumentViewerModal
        open={!!viewing}
        fileUrl={viewing?.fileUrl}
        title={viewing?.title}
        onClose={() => setViewing(null)}
      />
    </Container>
  );
}
